<div class="row">
    <div class="col-12">
        <div class=" text-center border" >
            <div class="ag-bg-red  row p-1" style="height: 3rem; border-radius: 10px 10px 0px 0px;">
                <span class="text-white col-12 col-md-4">Document</span>
                <span class="text-white col-12 col-md-2">Thème</span>
                <span class="text-white col-12 col-md-2">Commentaire</span>
                <span class="text-white col-12 col-md-2">Public</span>
                <span class="text-white col-12 col-md-2">Déposé le,</span>
            </div>
            <div class="p-1" style="height: 70vh; overflow-y: scroll; ">
                <div (click)="getFile(d)" class="row no-gutters border mb-3 line" *ngFor="let d of data">
                    <div  class="d-flex justify-content-start col-12 col-md-4" >
                        <div class="me-1">
                          <img src="assets/pdf.png" height="50" width="50" class="img-thumbnail">
                        </div>
                        <div class="align-self-center">
                          <span class="text-dark h5"><strong><small>{{d.filename}}</small></strong></span>
                        </div>
                      </div>
                      <div class="col-12 col-md-2 align-self-center">{{d.theme}}</div>
                      <div class="col-12 col-md-2 align-self-center">{{d.comment}}</div>
                      <div class="col-12 col-md-2 align-self-center">{{d.classroom?.name}}</div>
                      <div class="col-12 col-md-2 align-self-center">{{d.created_at | date:"dd-MM-yyyy"}}</div>
                </div>
             
               
            </div>
        </div>
    </div>
</div>